import { VolunteerOfMonthDto } from '@klubovna/api-client';

export interface VolunteersState {
  volunteerOfMonth: VolunteerOfMonthDto | null;
  loading: boolean;
  error: string | null;
}

export const initialVolunteersState: VolunteersState = {
  volunteerOfMonth: null,
  loading: false,
  error: null,
};
